
import { RuleAction } from "@/lib/types";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ReplyAction } from "./ReplyAction";
import { ForwardAction } from "./ForwardAction";
import { StopAction } from "./StopAction";

interface ActionBuilderProps {
  action: RuleAction;
  onChange: (action: RuleAction) => void;
}

type ActionType = "reply" | "forward" | "stop";

const actionTypes: { value: ActionType; label: string }[] = [
  { value: "reply", label: "Reply with Template" },
  { value: "forward", label: "Forward to Address" },
  { value: "stop", label: "Stop Processing" }
];

export function ActionBuilder({ action, onChange }: ActionBuilderProps) {
  // Derived from props: handleTypeChange writes the new type straight back
  // through onChange, so a local copy could only ever go stale.
  const type = action.type as ActionType;

  const handleTypeChange = (value: ActionType) => {
    // Set default value based on type
    let defaultValue: any;
    switch (value) {
      case "reply":
        defaultValue = { templateId: "", saveToSentItems: true, subject: "", loopPreventionMinutes: 60 };
        break;
      case "forward":
        defaultValue = { email: "" };
        break;
      case "stop":
        defaultValue = true;
        break;
      default:
        defaultValue = {};
    }
    
    onChange({
      type: value,
      value: defaultValue
    });
  };

  const handleValueChange = (value: any) => {
    onChange({
      ...action,
      value
    });
  };

  const renderActionEditor = () => {
    switch (type) {
      case "reply":
        return (
          <ReplyAction
            value={action.value || { templateId: "", saveToSentItems: true, subject: "", loopPreventionMinutes: 60 }}
            onChange={handleValueChange}
          />
        );
      case "forward":
        return (
          <ForwardAction
            value={action.value || { email: "" }}
            onChange={handleValueChange}
          />
        );
      case "stop":
        return (
          <StopAction
            value={action.value || true}
            onChange={handleValueChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium">Action Type</label>
        <Select value={type} onValueChange={handleTypeChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select action type" />
          </SelectTrigger>
          <SelectContent>
            {actionTypes.map((actType) => (
              <SelectItem key={actType.value} value={actType.value}>
                {actType.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div>
        {renderActionEditor()}
      </div>
    </div>
  );
}
